import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const OlympicsSummerIcon = observer(
    'OlympicsSummerIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => {
        return (
            <SvgIcon
                width='24'
                height='24'
                viewBox='0 0 50 50'
                fill='#061A32'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                onClick={onClick}
            >
                <path
                    d='M29.76,25.39h-2.28c1.78-1.2,2.69-3.58,2.12-5.66-.17-.63-.48-1.23-.88-1.74-.41-.52-.95-.87-1.41-1.34-.36-.38-.68-.8-.9-1.27-.18-.39-.31-.81-.39-1.23-.03-.19-.2-1-.02-1.14-.56.43-1.19,1.07-1.39,1.77-.22.77.15,1.79.41,2.51.27.72.69,1.52.28,2.29-.37.69-1.31.68-1.93.3-.69-.42-.91-1.23-.9-1.99,0-.36.05-1.26.43-1.47-2.58,1.5-3.62,4.91-1.9,7.48.4.6.94,1.12,1.55,1.5h-1.64c-.05,0-.09.04-.09.09v.24c0,.98.79,1.77,1.77,1.77h.45l1.05,8.38c.08.65.63,1.13,1.29,1.13.65,0,1.2-.49,1.28-1.14l1.03-8.38h.4c.98,0,1.77-.79,1.77-1.77v-.24s-.04-.09-.09-.09h0ZM23.67,25.39c-.26-.47-.35-1.04-.2-1.56.07-.26.19-.5.36-.7.17-.21.39-.35.57-.54.15-.15.27-.32.36-.52.07-.16.13-.33.16-.5.01-.08.08-.41,0-.46.23.17.48.43.56.72.09.31-.06.73-.17,1.02-.11.29-.28.62-.11.93.15.28.53.27.78.12.28-.17.37-.5.37-.81,0-.15-.02-.51-.17-.6,1,.58,1.43,1.88.84,2.9h-3.35Z'
                    fill='fill'
                />
            </SvgIcon>
        );
    }
);
